import { Navigate, Outlet, useLocation } from "@tanstack/react-router";
import { AppShell as WorkspaceShell } from "@/components/shell/AppShell";
import { Button } from "@/components/primitives";
import { useAihrAuth } from "@/lib/auth/useAihrAuth";

export function AppShell() {
  const auth = useAihrAuth();
  const location = useLocation();
  const isPublicRoute =
    location.pathname === "/signin" ||
    location.pathname === "/callback" ||
    location.pathname === "/403";

  if (isPublicRoute) {
    return <Outlet />;
  }

  if (auth.isLoading) {
    return <div className="center-screen">Loading Cosmos...</div>;
  }

  if (auth.error) {
    return (
      <div className="center-screen">
        <h1>Sign in failed</h1>
        <p>{auth.error.message}</p>
        <Button onClick={() => void auth.login()}>Try again</Button>
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  if (!auth.hasCosmosAccess) {
    return (
      <div className="center-screen">
        <h1>Access restricted</h1>
        <p>Cosmos is only available to users with the Cosmos role.</p>
        <Button onClick={() => auth.logout()}>Sign out</Button>
      </div>
    );
  }

  return (
    <WorkspaceShell>
      <Outlet />
    </WorkspaceShell>
  );
}
